import script from "./leftPie.vue?vue&type=script&setup=true&lang=js"
export * from "./leftPie.vue?vue&type=script&setup=true&lang=js"

import "./leftPie.vue?vue&type=style&index=0&id=8b660024&scoped=true&lang=css"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b660024"]])

export default __exports__